import React, { Component } from 'react';
import values from 'lodash/values';
import { withStyles } from '@material-ui/core/styles';
import { List, Grid, ButtonGroup } from '@material-ui/core/';
import SearchInput from '../Search/SearchInput';
import cloneDeep from 'lodash/cloneDeep';
import TreeNode from './TreeNode';
import SelectedNode from './SelectedNode';
import CustomButton from '../Button/Button';
import { exists } from '../../../utilities/utilitiesFunctions';

const styles = theme => ({
    nodesContainer: {
        marginTop: '15px',
        transitionDuration: '200ms',
        height: '35px',
        // width: theme.spacing.unit * 25,
        margin: '14px',
        '& svg': {
            height: '100%'
        }
    },
    expandedClass: {
        height: '35px',
        paddingTop: '0px',
        paddingRight: '8px',
        paddingBottom: '5px',
        color: 'black'
    },
    navClass: {
        width: '336px',
        paddingTop: '0px',
        overflow: 'auto',
        height: 'calc(100% - 119px)',
        position: 'absolute',
        fontSize: '12px',
        color: '#656565',
        '& .MuiListItem-button:hover': {
            backgroundColor: '#F7F9FC'
        }
    },
    pathContainer: {
        height: 'calc(100% - 119px)',
        overflow: 'auto',
        position: 'absolute',
        right: '0',
    },
    divSearch: {
        paddingBottom: '15px',
        display: 'inline-flex'
    },
    button: {
        width: '80px !important',
        height: '40px !important',
        lineHeight: '40px !important',
        right: '8px'
    },
    searchInput: {
        width: '100% !important'
    }
});
class Tree extends Component {

    constructor(props) {
        super(props);
        this.state = {
            nodes: this.props.data,
            currentSelection: this.initCurrentSelection(),
            listLoc: this.generateListLocation(),
            searchString: ''
        };
    }

    componentDidMount() {
        this.initSelect();
        this.calculateTreeHeight();
    }

    componentDidUpdate() {
        this.calculateTreeHeight();
    }

    generateListLocation = () => {
        let nodes = this.props.data;
        let listLoc = [];

        for (const node in nodes) {
            if (nodes.hasOwnProperty(node)) {
                listLoc.push({
                    value: nodes[node].nodeId,
                    label: node
                })
            }
        }

        return listLoc;
    }

    initCurrentSelection = () => {
        const { data, locationsSelected = [] } = this.props;
        let currentSelection = locationsSelected;

        for (const key in data) {
            if (data[key].isSelected) {
                currentSelection.push(data[key]);
            }
        }
        return currentSelection;
    }

    calculateTreeHeight = () => {
        const { classes } = this.props;
        setTimeout(function () {
            let listOfNodes = document.getElementsByClassName('node');
            let nodesContainer = document.getElementsByClassName('Nodes__Container')[0];
            let auxCalc = listOfNodes.length * 35 + 60 + 10;
            let maxHeight = window.innerHeight - (300 + 130);
            auxCalc = auxCalc > maxHeight ? maxHeight : auxCalc;
            nodesContainer.style.height = `${auxCalc}px`;

            for (let node of listOfNodes) {
                node.classList.add(classes.expandedClass);
            }
        }, 5);
    }

    getRootNodes = () => {
        const { nodes } = this.state;
        return values(nodes).filter(node => node.isRoot === 'true');
    }

    getChildNodes = (node) => {
        const { nodes } = this.state;
        if (!node.children) return [];
        return node.children.map(path => nodes[path]);
    }

    onToggle = (node) => {
        const { nodes } = this.state;
        nodes[node.path].isOpen = !node.isOpen;
        this.setState({ nodes });
    }

    selectAllChildren = (parent, check, nodes) => {
        if (parent.children.length > 0) {
            for (const child of parent.children) {
                nodes[child].isChecked = check;

                if (nodes[child].type === 'node') {
                    nodes[child].isSelected = (nodes[child].isSelectable && check);
                } else {
                    nodes[child].isSelected = check;
                }

                nodes = this.selectAllChildren(nodes[child], check, nodes);
            }
            return nodes;
        }
        return nodes;
    }

    selectAllParents = (node, status, nodes, init = false) => {
        if (node.isRoot) {
            node.isChecked = status ? true : this.siblingChecked(node, false, nodes);
            node.isSelected = false;
            node.isOpen = init ? true : node.isOpen;
        } else {
            if (node.parentPath !== '/' && !node.isRoot) {
                nodes[node.parentPath].isChecked = status ? true : this.siblingChecked(nodes[node.parentPath], false, nodes);
                nodes[node.parentPath].isSelected = status && nodes[node.parentPath].isSelectable ? this.allSiblingSelected(node, nodes) : false;
                nodes[node.parentPath].isOpen = init ? true : nodes[node.parentPath].isOpen;
                nodes = this.selectAllParents(nodes[node.parentPath], status, nodes, init);
            }
            if (node.parentPath === '/' && !node.isRoot) {
                nodes = this.selectAllParents(nodes[node.parentPath], status, nodes, init);
            }
        }
        return nodes;
    }

    allSiblingSelected = (node, nodes) => {
        if (nodes[node.parentPath].children.length === 1) {
            return true;
        } else {
            let auxSiblingCounter = 0;
            for (const child of nodes[node.parentPath].children) {
                auxSiblingCounter = nodes[child].isSelected ? auxSiblingCounter + 1 : auxSiblingCounter;
            }
            return auxSiblingCounter === nodes[node.parentPath].children.length;
        }
    }

    siblingChecked = (node, all, nodes) => {
        if (node.children.length === 1) {
            return nodes[node.children[0]].isChecked;
        } else {
            let auxSiblingCounter = 0;
            for (const child of node.children) {
                auxSiblingCounter = nodes[child].isChecked ? auxSiblingCounter + 1 : auxSiblingCounter;
            }
            if (all) {
                return auxSiblingCounter === node.children.length;
            }
            return auxSiblingCounter > 0;
        }
    }

    deSelectChildrens = (node, nodes) => {
        for (const child of node.children) {
            nodes[child].isSelected = false
        }
        return nodes;
    }

    updateNode = (node, nodes, init = false) => {
        const keys = Object.keys(nodes);
        let nodesAux = cloneDeep(nodes);

        let currentSelection = [];
        if (this.props.treeType === 'single') {

            for (const key in nodes) {
                if (nodesAux[key].type === "leaf") {
                    nodesAux[key].isSelected = false;
                }
            }
            if (init) {
                const selectedNode = node[0];
                nodesAux[selectedNode.path].isSelected = true;
                nodesAux[selectedNode.path].isChecked = true;

                currentSelection.push(nodesAux[selectedNode.path]);
            } else {
                nodesAux[node.path].isSelected = node.isSelectable || node.type === 'leaf' ? !node.isSelected : false;
                nodesAux[node.path].isChecked = !node.isChecked;

                if (nodesAux[node.path].isSelected) {
                    currentSelection.push(nodesAux[node.path]);
                }
            }
        }

        if (this.props.treeType === 'multi') {
            for (const key of keys) {
                nodesAux[key].isSelected = nodesAux[key].isChecked;
            }
            if (init) {
                nodesAux[node.path].isSelected = true;
                nodesAux[node.path].isChecked = true;
            } else {
                nodesAux[node.path].isSelected = node.isSelectable || node.type === 'leaf' ? !node.isChecked : false;
                nodesAux[node.path].isChecked = !node.isChecked;
            }
            nodesAux = this.selectAllChildren(nodesAux[node.path], nodesAux[node.path].isChecked, nodesAux);
            nodesAux = this.selectAllParents(nodesAux[node.path], nodesAux[node.path].isChecked, nodesAux, init);

            for (const key of keys) {
                if (nodesAux[key].type === 'node') {
                    nodesAux = this.allChildrenSelected(nodesAux[key], nodesAux);
                }
            }
            // special case for 1 children
            for (const key of keys) {
                if (nodesAux[key].type === 'node' && nodesAux[key].children.length === 1 && nodesAux[key].isSelected) {
                    nodesAux = this.checkSpecialCase(nodesAux[nodesAux[key].children[0]], key, nodesAux);
                }
            }

            if (init) {
                currentSelection.push(node);
            } else {
                for (const key of keys) {
                    if (nodesAux[key].isSelected) {
                        currentSelection.push(nodesAux[key]);
                    }
                }
            }
        }

        return { nodes: nodesAux, currentSelection };
    }

    initSelect = () => {
        let { currentLocation = [] } = this.props;
        let { nodes } = this.state;

        let data = { nodes: cloneDeep(nodes), currentSelection: [] };
        let allNodes = Object.keys(data.nodes);

        for (const loc of currentLocation) {
            let nodeFinded = allNodes.filter(function (node) {
                if (data.nodes[node].nodeId !== undefined) {
                    return data.nodes[node].nodeId === loc.nodeId;
                }
                return false
            }).map(function (node) {
                return data.nodes[node];
            });
            let dataAux = this.updateNode(nodeFinded, data.nodes, true);

            data.currentSelection = [...data.currentSelection, ...dataAux.currentSelection];
            data.nodes = dataAux.nodes;
        }

        this.props.selectedNodeHandler(data.nodes, data.currentSelection);
        this.setState({
            currentSelection: data.currentSelection,
            nodes: data.nodes
        });
    }

    onNodeSelect = (node) => {
        let { nodes } = this.state;
        let data = this.updateNode(node, nodes);

        this.props.selectedNodeHandler(data.nodes, data.currentSelection);
        this.setState({
            currentSelection: data.currentSelection,
            nodes: data.nodes
        });
    }

    checkSpecialCase = (node, target, nodes) => {
        if (node.children.length === 1) {
            return this.checkSpecialCase(nodes[node.children[0]], target, nodes);
        } else {
            nodes[target].isSelected = this.siblingChecked(node, true, nodes);
            return nodes;
        }
    }

    allChildrenSelected = (node, nodes) => {
        if (node.children.length === 1) {
            if (nodes[node.children[0]].isSelected && node.isSelectable) {
                return this.deSelectChildrens(node, nodes)
            } else {
                if (node.isSelected) {
                    nodes[node.path].isSelected = false;
                    return nodes;
                }
            }
        } else {
            let auxChildrenCounter = 0
            for (let child of node.children) {
                auxChildrenCounter = nodes[child].isSelected ? auxChildrenCounter + 1 : auxChildrenCounter
            }
            if ((node.children.length === auxChildrenCounter) && node.isSelectable) {
                return this.deSelectChildrens(node, nodes)
            } else {
                if (node.isSelected && auxChildrenCounter > 0) {
                    nodes[node.path].isSelected = false;
                    return nodes;
                }
            }
        }
        return nodes;
    }

    modifySelection = (currentSelection, index) => {
        let { nodes } = this.state;
        let nodesAux = cloneDeep(nodes);
        let currentSelectionAux = this.state.currentSelection;

        currentSelectionAux.splice(index, 1);
        nodesAux[currentSelection].isSelected = false;
        nodesAux[currentSelection].isChecked = false;
        nodesAux = this.selectAllChildren(nodesAux[currentSelection], false, nodesAux);
        nodesAux = this.selectAllParents(nodesAux[currentSelection], false, nodesAux);

        this.props.selectedNodeHandler(nodesAux, currentSelectionAux);
        this.setState({
            nodes: nodesAux,
            currentSelection: currentSelectionAux
        });
    }

    openAllParents = (nodeSelected, nodes) => {
        if (exists(nodes[nodeSelected].parentPath)) {
            nodes[nodes[nodeSelected].parentPath].isSearchedParent = true;
            this.openAllParents(nodes[nodeSelected].parentPath, nodes);
        }
    }

    searchInputHandler = (e) => {
        let value = e !== undefined ? e.target.value.toString().toLowerCase() : '';

        this.setState({ searchString: value });
    }

    searchButtonHandler = () => {
        let { nodes, searchString } = this.state;
        let nodesFounded = [];

        for (const node in nodes) {
            nodes[node].isSearched = false;
            nodes[node].isSearchedParent = false;
        }

        for (const node in nodes) {
            let splitPath = node.split('/');

            if ((splitPath[splitPath.length - 1].toLowerCase()).indexOf(searchString.toLowerCase()) !== -1 && searchString !== '') {
                nodes[node].isSearched = true;
                nodesFounded.push(node);
            }
        }

        for (const node of nodesFounded) {
            this.openAllParents(node, nodes);
        }

        this.setState({
            errorName: false,
            nodes
        })
    }

    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.searchButtonHandler();
        }
    }

    render() {
        const rootNodes = this.getRootNodes();
        const { classes, treeType, displaySearch = false } = this.props;
        const { searchString, currentSelection } = this.state;

        let searchInput = displaySearch ?
            <ButtonGroup>
                <SearchInput
                    className={classes.searchInput}
                    classes={classes}
                    value={searchString}
                    placeholder={'search'}
                    onChange={this.searchInputHandler}
                    onKeyPress={this.handleKeyPress}
                />
                <CustomButton
                    className={classes.button}
                    size={'full'}
                    color={'primary'}
                    onClick={this.searchButtonHandler}
                >
                    Search
                </CustomButton>
            </ButtonGroup>
            : '';
        return (
            <div className={`${classes.nodesContainer} Nodes__Container`}>
                {searchInput}
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <List className={classes.navClass} component="nav">
                            {rootNodes.map(node => (
                                <TreeNode
                                    key={node.description}
                                    node={node}
                                    getChildNodes={this.getChildNodes}
                                    onToggle={this.onToggle}
                                    onNodeSelect={this.onNodeSelect}
                                    treeType={treeType}
                                />
                            ))}
                        </List >
                    </Grid>
                    <Grid className={classes.pathContainer} item xs={6}>
                        <div className='divListPathContainer'>
                            <SelectedNode
                                modifySelection={this.modifySelection}
                                currentSelection={currentSelection}
                            />
                        </div>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

export default withStyles(styles)(Tree);